import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface TextProps {
  children?: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  weight?: 'normal' | 'medium' | 'semibold' | 'bold';
  color?: 'primary' | 'secondary' | 'text' | 'textLight' | 'error' | 'success' | 'gray';
  marginTop?: 'xsmall' | 'small' | 'medium' | 'large';
  marginBottom?: 'xsmall' | 'small' | 'medium' | 'large';
  className?: string;
  htmlFor?: string;
}

const StyledText = styled.span<TextProps>`
  font-family: ${theme.fonts.primary};
  
  ${({ size = 'md' }) => `font-size: ${theme.fontSizes[size]};`}
  
  ${({ weight = 'normal' }) => {
    switch (weight) {
      case 'medium': return `font-weight: ${theme.fontWeights.medium};`;
      case 'semibold': return `font-weight: ${theme.fontWeights.semibold};`;
      case 'bold': return `font-weight: ${theme.fontWeights.bold};`;
      default: return `font-weight: ${theme.fontWeights.normal};`;
    }
  }}
  
  ${({ color = 'text' }) => {
    switch (color) {
      case 'primary': return `color: ${theme.colors.primary};`;
      case 'secondary': return `color: ${theme.colors.secondary};`;
      case 'textLight': return `color: ${theme.colors.textLight};`;
      case 'error': return `color: ${theme.colors.error};`;
      case 'success': return `color: ${theme.colors.success};`;
      case 'gray': return `color: ${theme.colors.textLight};`;
      default: return `color: ${theme.colors.text};`;
    }
  }}
  
  ${({ marginTop }) => {
    switch (marginTop) {
      case 'xsmall': return `margin-top: ${theme.spacing.xs};`;
      case 'small': return `margin-top: ${theme.spacing.sm};`;
      case 'medium': return `margin-top: ${theme.spacing.md};`;
      case 'large': return `margin-top: ${theme.spacing.lg};`;
      default: return '';
    }
  }}
  
  ${({ marginBottom }) => {
    switch (marginBottom) {
      case 'xsmall': return `margin-bottom: ${theme.spacing.xs};`;
      case 'small': return `margin-bottom: ${theme.spacing.sm};`;
      case 'medium': return `margin-bottom: ${theme.spacing.md};`;
      case 'large': return `margin-bottom: ${theme.spacing.lg};`;
      default: return '';
    }
  }}
`;

export const Text: React.FC<TextProps> = ({ children, as = 'span', ...props }) => {
  return (
    <StyledText as={as} {...props}>
      {children}
    </StyledText>
  );
};